import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import jsPDF from "jspdf";
import loadingSpinner from './../../assets/loading.gif';

function SummaryReportByMonthAndDepartment({isHideSideMenu}) {
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [company, setCompany] = useState([]);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);

    const downloadPDF = useCallback(async (data) => {
        // Create a new jsPDF instance
        const _doc = new jsPDF();

        const drawLine = (doc, lineX, lineY) => {
            const startX = lineX;
            const endX = doc.internal.pageSize.getWidth() - 10; // Width of page minus some margin
            const startY = lineY;
            doc.line(startX, startY, endX, startY);
        };
        const title = (doc, title, titleX, titleY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            // doc.setTextColor("#668fca");
            doc.setLineWidth(0.5);
            doc.text(title, titleX, titleY);
        }
        const info = (doc, label, labelX, labelY) =>{
            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);
            doc.text(label, labelX, labelY); 
        }
        
        // Add the image to the PDF
        const imgData = `data:image/png;base64,${company.logo}`;
        _doc.addImage(imgData, 'PNG', 5, 5, 70, 30);
        
        title(_doc, `Monthly Summary Report By Department For The Month Of ${month} ${year}`, 10, 35);

        let totalMTDHrsBillable = 0;
        let totalMTDHrsNonBillable = 0;
        let totalMTDHrsTotalBillable = 0;

        let totalMTDPercentageBillable = 0;
        let totalMTDPercentageNonBillable = 0;
        let totalMTDPercentageTotalBillable = 0;

        let totalYTDHrsBillable = 0;
        let totalYTDHrsNonBillable = 0;
        let totalYTDHrsTotalBillable = 0;

        let totalYTDPercentageBillable = 0;
        let totalYTDPercentageNonBillable = 0;
        let totalYTDPercentageTotalBillable = 0;

        drawLine(_doc, 10, 50);
        title(_doc, `Summary`, 10, 55);
        title(_doc, `Billable`, 10, 65);
        title(_doc, `Non-Billable`, 10, 70);
        title(_doc, `Total`, 10, 75);

        title(_doc, `MTD Hrs`, 70, 55);
        info(_doc, totalMTDHrsBillable.toString(), 70, 65);
        info(_doc, totalMTDHrsNonBillable.toString(), 70, 70);
        info(_doc, totalMTDHrsTotalBillable.toString(), 70, 75);

        title(_doc, `MTD %`, 110, 55);
        info(_doc, `${totalMTDPercentageBillable.toString()} %`, 110, 65);
        info(_doc, `${totalMTDPercentageNonBillable.toString()} %`, 110, 70);
        info(_doc, `${totalMTDPercentageTotalBillable.toString()} %`, 110, 75);

        title(_doc, `YTD Hrs`, 150, 55);
        info(_doc, totalYTDHrsBillable.toString(), 150, 65);
        info(_doc, totalYTDHrsNonBillable.toString(), 150, 70);
        info(_doc, totalYTDHrsTotalBillable.toString(), 150, 75);

        title(_doc, `YTD %`, 185, 55);
        info(_doc, `${totalYTDPercentageBillable.toString()} %`, 185, 65);
        info(_doc, `${totalYTDPercentageNonBillable.toString()} %`, 185, 70);
        info(_doc, `${totalYTDPercentageTotalBillable.toString()} %`, 185, 75);

        drawLine(_doc, 10, 80);

        // Add data here
        let y = 90; // Starting Y position for data
        const pageHeight = _doc.internal.pageSize.getHeight();
        const threshold = pageHeight - 20; 

        data.forEach((item) => {
            if (y > threshold) {
                _doc.addPage(); // Add new page
                y = 20;
            }

            const initialMTDHrsBillable = 0;
            const initialMTDHrsNonBillable = 0;
            const initialMTDHrsTotalBillable = 0;

            const initialMTDPercentageBillable = 0;
            const initialMTDPercentageNonBillable = 0;
            const initialMTDPercentageTotalBillable = 0;

            const initialYTDHrsBillable = 0;
            const initialYTDHrsNonBillable = 0;
            const initialYTDHrsTotalBillable = 0;

            const initialYTDPercentageBillable = 0;
            const initialYTDPercentageNonBillable = 0;
            const initialYTDPercentageTotalBillable = 0;

            drawLine(_doc, 10, y);
            title(_doc, `${item.description} Summary`, 10, y + 5);
            title(_doc, `Billable`, 10, y + 15);
            title(_doc, `Non-Billable`, 10, y + 20);
            title(_doc, `Total`, 10, y + 25);

            title(_doc, `MTD Hrs`, 70, y + 5);
            info(_doc, initialMTDHrsBillable.toString(), 70, y + 15);
            info(_doc, initialMTDHrsNonBillable.toString(), 70, y + 20);
            info(_doc, initialMTDHrsTotalBillable.toString(), 70, y + 25);

            title(_doc, `MTD %`, 110, y + 5);
            info(_doc, `${initialMTDPercentageBillable.toString()} %`, 110, y + 15);
            info(_doc, `${initialMTDPercentageNonBillable.toString()} %`, 110, y + 20);
            info(_doc, `${initialMTDPercentageTotalBillable.toString()} %`, 110, y + 25);

            title(_doc, `YTD Hrs`, 150, y + 5);
            info(_doc, initialYTDHrsBillable.toString(), 150, y + 15);
            info(_doc, initialYTDHrsNonBillable.toString(), 150, y + 20);
            info(_doc, initialYTDHrsTotalBillable.toString(), 150, y + 25);

            title(_doc, `YTD %`, 185, y + 5);
            info(_doc, `${initialYTDPercentageBillable.toString()} %`, 185, y + 15);
            info(_doc, `${initialYTDPercentageNonBillable.toString()} %`, 185, y + 20);
            info(_doc, `${initialYTDPercentageTotalBillable.toString()} %`, 185, y + 25);

            drawLine(_doc, 10, y + 30);

            y += 40; // Increment Y position for next row
        });

        // Save the PDF
        _doc.save(`Summary_Report_By_Month_And_Department.pdf`);
    }, [month, year, company]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Department/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            downloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [downloadPDF]);

    const generate = () =>{
        if(!month
            || !year
            || !company
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Summary Report By Month And Department"}</span>
                            </div>
                            <h3>Generate Summary Report By Month And Department</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row" style={{justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Month</div>
                                    <div className="info-item-input">
                                        <Month month={month} setMonth={setMonth}/>
                                    </div>
                                    <span style={{
                                                visibility: !month && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Year</div>
                                    <div className="info-item-input">
                                        <Year year={year} setYear={setYear}/>
                                    </div>
                                    <span style={{
                                                visibility: !year && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect company={company} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !company && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="sssReportGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function Month({month, setMonth}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setMonth(event.target.value);
        setIsSelected(true);
    };

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    
    useEffect(() => {
        if(month !== "" && month !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [month]);

    return (
        <div>
            <select id="monthSSSReport-select" value={month} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose a month</option>
                {months.map((monthName, index) => (
                    <option key={index} value={monthName}>{monthName}</option>
                ))}
            </select>
        </div>
    );
};
function Year({year, setYear}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setYear(event.target.value);
        setIsSelected(true);
    };

    // Generate years from 2019 to the current year
    const getCurrentYear = () => new Date().getFullYear();
    const startYear = 2019;
    const years = Array.from({ length: getCurrentYear() - startYear + 1 }, (_, index) => (startYear + index).toString());

    useEffect(() => {
        if(year !== "" && year !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [year]);

    return (
        <div>
            <select id="yearSSSReport-select" value={year} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose a year</option>
            {years.map((yearName, index) => (
                <option key={index} value={yearName}>{yearName}</option>
            ))}
            </select>
        </div>
    );
};
function CompanyTypeSelect({company, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
            setIsSelected(true);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (company !== "" && company !== 0 && company !== null && company !== undefined && company?.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [company]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={company} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((company) => ( 
                SetCompanyType(company)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}

export default SummaryReportByMonthAndDepartment
